'use client';

import { useEffect, useState } from 'react';

// Thin gold progress bar pinned to the top of the viewport that fills as the
// reader scrolls the article. Pure scrollY/maxScroll math — no per-frame
// RAF, just the scroll event. Hidden by default until the reader is past the
// fold so it doesn't flash on initial paint.
export function ReadingProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max <= 0 ? 0 : Math.min(1, Math.max(0, window.scrollY / max));
      setProgress(pct);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <div
      role="progressbar"
      aria-label="Reading progress"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(progress * 100)}
      style={{
        position: 'fixed',
        top: 'var(--nav-height, 72px)',
        left: 0,
        right: 0,
        height: 2,
        zIndex: 60,
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          width: `${progress * 100}%`,
          height: '100%',
          background: 'linear-gradient(90deg, var(--accent), var(--indigo))',
          transition: 'width 80ms linear',
          willChange: 'width',
        }}
      />
    </div>
  );
}
